import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Modal, Radio, TextField, TextareaAutosize, Typography } from '@mui/material'
import React from 'react'
import { useState } from 'react';
import { RxCross1 } from "react-icons/rx";
import CustomButtoncolor from '../custom-button/customColorButton';
// import { sendReminder } from '../../store/crm/pos';
import { sendReminder } from '../../store/crm/pos';
import { useDispatch } from 'react-redux';
import { toast } from 'react-hot-toast';
import { Label } from '@mui/icons-material';
import { setEmail } from '../../store/crm/crm';
import CancelIcon from '@mui/icons-material/Cancel';
import { useFormik } from 'formik';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Customcolorbtn from '../custom-button/customeColorCalender';
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import CloseIcon from '@mui/icons-material/Close';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatStrikethroughIcon from '@mui/icons-material/FormatStrikethrough';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import LinkIcon from '@mui/icons-material/Link';
import ImageIcon from '@mui/icons-material/Image';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import { Select, MenuItem } from '@mui/material';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    p: '27px 12px',
    borderRadius:'6px',
    '@media (max-width: 550px)': {
      width: "95%",
    },
    gap:"5px"
  };
  const wrapper={
    alignItems:"center",
  }
  const heading={
    fontSize:"18px",
    fontFamily:'helvetica-lt-std-roman',
    fontWeight:'400',
    textAlign:"center",
    width:'100%'

  }
 
  export const inputStyle = {
    background: "#F5DFEA",
    borderRadius: '4px',
    ".MuiOutlinedInput-notchedOutline": {
        borderWidth: "0!important"
    },
    ".MuiInputBase-input": {
        borderColor: " #F5DFEA",
        height: "19px",
        minHeight: 'unset',
        "&:focus": {
            borderColor: "#F5DFEA",
            outline: "none",
            "input": {
                height: '19px'
            }
        },
        "&:hover": {
            borderColor: "#F5DFEA",
            outline: "none",
        }
    }
}
export const btnwrappe ={
  marginTop:"5px",
  display:"flex",
  justifyContent:"flex-end",
  gap:"10px"
  
}
 export const textareaStyle = {

  height: '250px',
  border:"none",
    background: "#F5DFEA",
    borderRadius: '4px',
    outline:"none",
      "&:focus": {
        borderColor: "#F5DFEA",
        outline: "none",
      },
      "&:hover": {
        borderColor: "#F5DFEA",
        outline: "none",
    }
    
};

const SetEmailCalenderModal= ({ customer_id, isbtn, panelMode, onPanelClose, onActionStart, onActionEnd }) => {
  const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const validate = (values) => {
      const errors = {};
  
      if (!values.message) {
        errors.message = "Message is required";
      }
  
      if (!values.subject) {
        errors.subject = "Subject is required";
      }
  
      return errors;
    };
  
    const formik = useFormik({
      initialValues: {
        message: "",
        subject: "",
      },
      validate,
      onSubmit: (values) => {
      handleSentemail(values.message, values.subject);
      },
    });
  
    const handleSentemail= async (message, subject) => {
      try {
        const payload = {
          customer_id: customer_id,
          message: message,
          subject: subject,
        };
        if (panelMode) {
          onActionStart?.()
          dispatch(setEmail(payload)).finally(() => {
            formik.resetForm()
            onActionEnd?.('Send Email Successfully')
          })
          return
        }
        dispatch(setEmail(payload));
        toast.success('Send Email Successfully');
        formik.resetForm();
        handleClose();
      } catch (error) {
        //console.log('Error sending email', error);
      }
    };
    const handleCloseModal = () => {
      handleClose(); 
    };
    
  if (panelMode) {
    const fieldLabel = (icon, text) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: '6px' }}>
        {React.cloneElement(icon, { sx: { fontSize: 14, color: '#A72C68' } })}
        <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#1a1a2e' }}>{text}</Typography>
      </Box>
    );
    const toolbarBtn = (icon) => (
      <IconButton size="small" sx={{ p: 0.5, color: '#3b4252', borderRadius: '6px', '&:hover': { background: '#FAEFF5', color: '#A72C68' } }}>
        {React.cloneElement(icon, { sx: { fontSize: 16 } })}
      </IconButton>
    );
    const MSG_MAX = 5000;
    const msgValue = formik.values.message || '';
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fff' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', px: 2.5, py: 2, borderBottom: '1px solid #F1F2F6', flexShrink: 0, gap: 1.25 }}>
          <Box sx={{ width: 38, height: 38, borderRadius: '10px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <MailOutlineIcon sx={{ color: '#A72C68', fontSize: 20 }} />
          </Box>
          <Typography sx={{ flex: 1, fontWeight: 700, fontSize: '16px', fontFamily: 'helvetica-lt-std-bold,sans-serif', color: '#1a1a2e' }}>Send Email</Typography>
          <IconButton size="small" onClick={() => onPanelClose?.()} sx={{ color: '#9A9797', '&:hover': { color: '#EB5757', background: '#ffeaea' } }}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto', p: 2.5 }}>
          {/* Subject */}
          <Box sx={{ mb: 2 }}>
            {fieldLabel(<MailOutlineIcon />, 'Subject')}
            <TextField
              fullWidth
              name="subject"
              placeholder="Enter email subject..."
              value={formik.values.subject}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{
                '& .MuiOutlinedInput-root': { borderRadius: '10px', background: '#fff', '& fieldset': { borderColor: '#ECEDF2' }, '&:hover fieldset': { borderColor: '#E5A8C2' }, '&.Mui-focused fieldset': { borderColor: '#A72C68' } },
                '& .MuiInputBase-input': { fontSize: '13px', py: '11px' },
              }}
            />
            {formik.touched.subject && formik.errors.subject && <Typography color="error" sx={{ fontSize: '12px', mt: 0.5 }}>{formik.errors.subject}</Typography>}
          </Box>

          {/* Message */}
          <Box sx={{ mb: 2 }}>
            {fieldLabel(<BorderColorIcon />, 'Message')}
            <Box sx={{ position: 'relative', border: '1px solid #ECEDF2', borderRadius: '10px', background: '#fff', transition: 'border-color 0.15s', '&:focus-within': { borderColor: '#A72C68' } }}>
              <TextareaAutosize
                minRows={8}
                name="message"
                placeholder="Type your message here..."
                value={msgValue}
                maxLength={MSG_MAX}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{ width: '100%', resize: 'vertical', padding: '12px', border: 'none', outline: 'none', fontFamily: 'inherit', fontSize: '13px', background: 'transparent', color: '#1a1a2e', boxSizing: 'border-box', minHeight: 180 }}
              />
              <Typography sx={{ position: 'absolute', right: 12, bottom: 6, fontSize: '11px', color: '#9ca3af' }}>{msgValue.length}/{MSG_MAX}</Typography>
            </Box>
            {formik.touched.message && formik.errors.message && <Typography color="error" sx={{ fontSize: '12px', mt: 0.5 }}>{formik.errors.message}</Typography>}
          </Box>
        </Box>

        {/* Footer */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.25, px: 2.5, py: 1.75, borderTop: '1px solid #F1F2F6', flexShrink: 0, background: '#fff' }}>
          <Button
            variant="outlined"
            onClick={() => onPanelClose?.()}
            sx={{
              textTransform: 'none', borderRadius: '10px', px: 3, py: 1,
              fontWeight: 600, fontSize: '13px',
              backgroundColor: '#EB5757', color: '#fff',
              border: '1px solid #EB5757',
              boxShadow: 'none',
              '&:hover': { backgroundColor: '#fff', color: '#EB5757', border: '1px solid #EB5757', boxShadow: 'none' },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={<SendIcon sx={{ fontSize: '16px !important' }} />}
            onClick={formik.handleSubmit}
            sx={{
              background: '#27AE60', color: '#fff',
              border: '1px solid #27AE60',
              textTransform: 'none', borderRadius: '10px', px: 3, py: 1,
              fontWeight: 700, fontSize: '13px',
              boxShadow: 'none',
              '&:hover': { background: '#219653', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none' },
            }}
          >
            Send Email
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Customcolorbtn
      handleClick={handleOpen}
       mainColor={"#3d9621ed"}
       size="md"
       val='Send Email'
       style={{ width:'100%' }}
    icon={isbtn ? <MailOutlineIcon /> : null}                               
    />
   <Modal
   style={{}}
     open={open}
     onClose={handleClose}
     aria-labelledby="modal-modal-title"
     aria-describedby="modal-modal-description"
   >
     <Box sx={style}>
     <Grid container spacing={1}  sx={wrapper}>
     <Grid item lg={12} style={{display:"flex", justifyContent:"space-between",width:"100%" }}>
      <ArrowBackIosNewIcon onClick={handleCloseModal} />
       <Typography
         id="modal-modal-title"
         sx={heading}
         
       >
    Send Email
       </Typography>
     </Grid>
     <Box style={{marginTop:'26px',width:"100%",padding:"0px 3px 0px 10px"}}>
     <Grid item lg={12} md={12} sm={12} style={{marginBottom:"10px"}} >
                            
       <FormControl fullWidth>
<Typography>Subject</Typography> 
  <TextField
          fullWidth
          name="subject"
           sx={inputStyle}
           placeholder="" 
           value={formik.values.subject}
           onChange={formik.handleChange}
           onBlur={formik.handleBlur}              
           />
            {formik.touched.subject && formik.errors.subject && (
    <Typography color="error">{formik.errors.subject}</Typography>
  )}
    </FormControl>
  </Grid>
  <Grid item lg={12} md={12} sm={12} style={{marginTop:"10px",marginBottom:"15px"}} >
<Typography> Message </Typography> 
<FormControl fullWidth>
    <TextareaAutosize
      style={textareaStyle}
      rows={6}
      name='message'
      placeholder=""
      value={formik.values.waletnotes}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}   
    />
    {formik.touched.waletnotes && formik.errors.waletnotes && (
      <Typography color="error">{formik.errors.waletnotes}</Typography>
    )}
  </FormControl>
  </Grid>
    <Grid item lg={12} md={12}sm={12} sx={btnwrappe}>
    <CustomButtoncolor
       mainColor={"#4F4F4F"}
       size="md"
       val='Cancel'
       style={{
        padding:'7px 5px',
        fontSize: "18px",
        minWidth:'max-content',
        borderRadius: "6px!important",
        width: "15%",
        "@media (minWidth: 420px)": {
            width: 'auto'
        },
        
    }}  
    handleClick={handleCloseModal}                                
    />
  <Button  variant="contained"  size="large"
   style={{
   borderRadius:'8px'}}
   sx={{
     background: '#27AE60',
     color: '#fff',
     border: '1px solid #27AE60',
     boxShadow: 'none',
     '&:hover': {
       background: '#219653',
       color: '#fff',
       border: '1px solid #27AE60',
       boxShadow: 'none',
     },
   }}
   onClick={formik.handleSubmit}>
         Send Email
       </Button>
   </Grid>
     </Box>

   </Grid>
 
     </Box>
   </Modal>
   </>
  )
}

export default SetEmailCalenderModal;

